import { takeLatest, put, call, select } from 'redux-saga/effects';
import { ADD_USER_TO_BOOKING_SAGA } from "../sagaTypes";
import { loaderAction, bookingFormAction, dropdownAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { getBookingUsersSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/add_booking_user`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerAddUserToBooking(args) {
    const user = yield select(state => state.user);
    const bookingForm = yield select(state => state.bookingForm);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('user', args.data.user_id);
        formData.append('booking_id', args.data.booking_id);
        formData.append('child_id', args.data.child_id || '0');

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            growl({ type: 'success', message: response.message });
            // Закрываем выпадающий список
            yield put(dropdownAction(null));
            // Очищаем данные из инпута и массив с найденными пользователями
            yield put(bookingFormAction({
                ...bookingForm,
                users: [],
                userInput: ''
            }));
            // Обновляем список пользователей
            yield put(getBookingUsersSagaAction({
                booking_id: args.data.booking_id
            }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherAddUserToBooking() {
    yield takeLatest(ADD_USER_TO_BOOKING_SAGA, workerAddUserToBooking);
}